import { Box, Typography, Button, IconButton, TextField } from '@mui/material'
import { useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import React from 'react'
import { InputAdornment } from "@mui/material";
import { toast } from 'react-toastify';
import { store_referral } from '../../api/ControllApi';

import { useModal } from '../../context/ModalContext';

const ReferFriends = ({ id }) => {
    const [copied, setCopied] = useState(false);
    const [referralEmail, setReferralEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const { requireLogin } = useModal()
    const validateEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };


    const referCode = "ABC123";

    const handleCopy = () => {
        navigator.clipboard.writeText(referCode);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };


    const handleReferralSubmit = async () => {


        if (!referralEmail) {
            toast.error("Email is required");
            return;
        }

        if (!validateEmail(referralEmail)) {
            toast.error("Enter a valid email address");
            return;
        }

        const payload = {
            email: referralEmail,
            property_id: id,
        };

        try {
            const res = await store_referral(payload);

            toast.success(res?.message || "Referral sent successfully");

            setReferralEmail("");
            setEmailError("");
        } catch (err) {

            toast.error(err?.response?.data?.message || "Failed to send referral");
        }
    };


    return (
        <Box sx={{ py: 6 }}>


            <Box sx={{ display: { xs: "block", md: "flex" }, alignContent: "center", gap: 3 }}>
                <Typography variant='h6' sx={{ fontWeight: 600 }}>Refer Friends & Join the Scheme Group</Typography>
                <Button
                    sx={{
                        textTransform: "none",
                        color: "primary",
                        backgroundImage: "linear-gradient(180deg, #F8F6F6 0%, #DDDDDD 100%)", // top to bottom
                        borderRadius: 2,
                        px: 4,
                        boxShadow: 1,
                        "&:hover": {
                            backgroundImage: "linear-gradient(180deg, #DDDDDD 0%, #F8F6F6 100%)", // hover gradient
                        },
                    }}
                >
                    No Referral Join Group
                </Button>

            </Box>


            <Typography sx={{ fontSize: 18, py: 2, color: "text.secondary" }}>
                Invite your friends or family to join this scheme and purchase plots together.When your reference successfully reserves a plot, both of you get exclusive benefits and can join the private group chat to discuss the project, updates, and progress.
            </Typography>

            {/* <Box sx={{ display: { xs: 'block', sm: "flex" }, alignItems: "baseline", gap: 5 }}>
                <Box sx={{ display: 'flex', alignItems: "center", gap: 2, mb: 3 }}> */}
            {/* <Typography fontWeight={600}>
                        Refer Code:
                    </Typography> */}

            {/* <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,

                                borderRadius: 2,

                                maxWidth: 300,
                            }}>
                            <Typography fontWeight={600} sx={{ color: "primary.main" }}>{referCode}</Typography>
                            <IconButton size="small" onClick={handleCopy}>
                                <ContentCopyIcon fontSize="small" color='primary.main' />
                            </IconButton>
                            {copied && (
                                <Typography sx={{ color: "green", fontSize: 12 }}>Copied!</Typography>
                            )}
                        </Box> */}

            {/* </Box> */}

            {/* <Box sx={{ display: "flex", flexDirection: "column", gap: 1, maxWidth: 300 }}>
                    <Typography variant="body2" fontWeight={500}>
                        Enter Referral Email
                    </Typography>

                    <TextField
                        placeholder="Referral Email"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={referralEmail}
                        onChange={(e) => setReferralEmail(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Button
                                        variant="contained"
                                        size="small"
                                        // onClick={handleReferralSubmit}
                                        sx={{
                                            textTransform: "none",
                                            minWidth: 70,
                                            height: 30,
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box> */}


            {/* </Box> */}


            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, maxWidth: 300 }}>
                <Typography variant="body2" fontWeight={500}>
                    Enter Referral Email
                </Typography>

                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <TextField
                        placeholder="Referral Email"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={referralEmail}
                        onChange={(e) => setReferralEmail(e.target.value)}
                    />

                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => requireLogin(() => handleReferralSubmit())}
                        sx={{
                            textTransform: "none",
                            whiteSpace: "nowrap",
                            height: "40px",
                        }}
                    >
                        Submit
                    </Button>
                </Box>
            </Box>



        </Box>
    )
}

export default ReferFriends
